import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";

import { makeStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table.js";
import { Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";

import api from "assets/services/api";

import ModalAddTabulation from "components/ModalAddTabulation/ModalAddTabulation";
import ModalDeleteTabulation from "components/ModalDeleteTabulation/ModalDeleteTabulation";
import ModalUpdateTabulation from "components/ModalUpdateTabulation/ModalUpdateTabulation";

const styles = {
    imageTabulation: {
        width: 90,
        height: 90,
        borderRadius: 90,
        marginRight: 20 / 2
    }
}

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
function ModalViewTabulation(props) {

    const [tabulation, setTabulation] = useState([]);
    const classes = useStyles();
    const classes2 = useStyles2();
    const [index, setIndex] = useState({ id: 0 });
    const id_client = props.props.id === undefined ? 0 : props.props.id
    const [modalDeleteTabulation, setModalDeleteTabulation] = useState(false);
    const [modalUpdateTabulation, setModalUpdateTabulation] = useState(false);
    const [modalAddTabulation, setModalAddTabulation] = useState(false);

    useEffect(() => {
        handleShowTabulation()
    }, [props.props.id])

    async function handleShowTabulation() {
        const response = await api.get('tabulation/client/' + props.props.id);
        setTabulation(response.data);
    }

    function callModalDeleteTabulation(index) {
        setIndex(index)
        setModalDeleteTabulation(true)
    }

    function callModalUpdateTabulation(index) {
        setIndex(index)
        setModalUpdateTabulation(true)
    }

    function callModalAddTabulation(index) {
        setModalAddTabulation(true)
    }

    function getTabulation() {
        let teste = [];
        for (let i = 0; i < tabulation.length; i++) {
            teste[i] = [];
            teste[i].push(
                <img
                    className={classes.imageTabulation}
                    src={require(`assets/img/products/${tabulation[i].new_code}.png`)}
                    title={tabulation[i].name}
                    alt={tabulation[i].name}
                />
            );
            teste[i].push(tabulation[i].name);
            //teste[i].push(tabulation[i].standart_price);
            teste[i].push(tabulation[i].price_of_product);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top"
                        title="Editar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModalUpdateTabulation(tabulation[i])}

                        >
                            <Edit
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }
                            />
                        </IconButton>

                    </Tooltip>
                    : <div />
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => callModalDeleteTabulation(tabulation[i])}
                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div>
            )

        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Tabela de preços de {props.props.social_reason}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table
                    tableHeaderColor="primary"
                    tableHead={["", "Produto", "Preço", "Ações"]}
                    tableData={getTabulation()}
                />
                <div className="d-flex justify-content-center">
                    <Button color="success" onClick={callModalAddTabulation}>
                        Adicionar tabelação
                    </Button>
                </div>
            </Modal.Body>
            <ModalAddTabulation key={String("AddTabu_" + index.id)} id_client={id_client} show={modalAddTabulation} onHide={() => setModalAddTabulation(false)} handleShowTabulation={handleShowTabulation} />
            <ModalDeleteTabulation key={String("DeleteTabu_" + index.id)} props={index} show={modalDeleteTabulation} onHide={() => setModalDeleteTabulation(false)} handleShowTabulation={handleShowTabulation} />
            <ModalUpdateTabulation key={String("UpdTabu_" + index.id)} props={index} show={modalUpdateTabulation} onHide={() => setModalUpdateTabulation(false)} handleShowTabulation={handleShowTabulation} />
        </Modal>
    );
}

export default ModalViewTabulation;